import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_CRYPTO_KEY;

const decryptECB = (cipherText) => {
  try {
    const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
    const bytes = CryptoJS.AES.decrypt(cipherText, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return bytes.toString(CryptoJS.enc.Utf8) || null;
  } catch (e) {
    return null;
  }
};

export const decryptData = (cipherText) => {
  if (!cipherText) return null;

  try {
    const formattedText = cipherText.toString().replace(/ /g, '+');
    const rawData = CryptoJS.enc.Base64.parse(formattedText);

    if (rawData.sigBytes >= 32) {
      try {
        const iv = CryptoJS.lib.WordArray.create(rawData.words.slice(0, 4), 16);
        const cipherTextWords = CryptoJS.lib.WordArray.create(
          rawData.words.slice(4),
          rawData.sigBytes - 16
        );

        const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);

        const decryptedBytes = CryptoJS.AES.decrypt(
          { ciphertext: cipherTextWords },
          key,
          {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          }
        );

        const decrypted = decryptedBytes.toString(CryptoJS.enc.Utf8);
        if (decrypted) {
          return decrypted;
        }
      } catch (e) {
        // Fallback to legacy ECB mode if CBC fails
      }
    }

    return decryptECB(formattedText);
  } catch (e) {
    return decryptECB(cipherText);
  }
};

const isProbablyEncrypted = (value) => {
  if (!value || typeof value !== 'string') return false;

  try {
    const decrypted = decryptData(value);
    return !!decrypted;
  } catch (e) {
    return false;
  }
};

export const encryptData = (value) => {
  if (value === undefined || value === null) return null;

  const stringValue = value.toString();

  if (isProbablyEncrypted(stringValue)) {
    return stringValue;
  }

  const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
  const iv = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(stringValue, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const combined = iv.clone().concat(encrypted.ciphertext);

  return CryptoJS.enc.Base64.stringify(combined);
};
